export default __webpack_public_path__ + "static/media/line-double.081eed68.svg";